<template>
  <b-modal
    :visible="isVisible"
    @hide="$emit('hide')"
    class="border-r-5"
    header-class="hidden"
    body-class="fundo-cinza-mix"
    footer-class="px-2 mt-3  no-border"
  >
    <div class="row">
      <div class="col-12 text-center">
        <div class="row px-3">
          <div class="col-12">
            <button
              @click="$emit('hide')"
              class="close texto-escuro"
              aria-label="Fechar"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="col-12 text-left">
            <h2 style="color: white">Confirmação de cancelamento da fatura</h2>
          </div>
          <div class="col-12 text-left mb-2 mt-4">
            <span class="texto-branco" style="font-family: 'roboto-light'">
              Ao cancelar esta fatura, o contrato associado também será cancelado. Tem certeza de que deseja continuar?
            </span>
          </div>
        </div>
      </div>
    </div>
    <template #modal-footer>
      <div class="row px-3">
        <div class="col-12">
          <div class="row align-items-center">
            <div class="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12 mt-2">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="confirmarCancelamento" v-model="confirmarCancelamento">
                <label class="form-check-label" for="confirmarCancelamento">
                  Estou de acordo com o cancelamento
                </label>
              </div>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 mt-2">
              <button
                class="btn btn-customizado btn-customizado-cinza-outline"
                @click="cancelarFatura"
                :disabled="!confirmarCancelamento"
              >
                Cancelar fatura
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </b-modal>
</template>
<script>
import ConfirmacaoCancelamentoFatura from './js/confirmacao-cancelamento-fatura'
export default ConfirmacaoCancelamentoFatura
</script>
